// German for the LATEST zone: the newest entries of the merged stream.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Latest': 'Neueste',
  '{n} new in the last 14 days': '{n} neu in den letzten 14 Tagen',
  '{n} new since {date}': '{n} neu seit {date}',
  'nothing new in the last 14 days': 'nichts Neues in den letzten 14 Tagen',
  'nothing new since {date}': 'nichts Neues seit {date}',
  'newest {shown} of {total}': 'neueste {shown} von {total}',
  'Library': 'Bibliothek',
  'Full timeline': 'Ganze Zeitachse',
  'Nothing on the record yet — no document ingested, no timeline event written.': 'Noch nichts im Protokoll — kein Dokument eingelesen, kein Ereignis auf der Zeitachse erfasst.',
  'superseded by': 'ersetzt durch',
  'No summary on record.': 'Keine Zusammenfassung vorhanden.',
  'show the newest six': 'die neuesten sechs zeigen',
  '{n} older on this strip': '{n} ältere auf diesem Streifen',
  // entry.kind ?? entry.layer — the event kinds and the two layers
  'document': 'Dokument',
  'event': 'Ereignis',
  'meeting': 'Besprechung',
  'decision': 'Entscheidung',
  'signature': 'Unterschrift',
  'commitment': 'Zusage',
  'milestone': 'Meilenstein',
  'participant': 'Teilnehmer',
  'note': 'Notiz',
}, 'ClientLatest');
